import { useQuery } from 'react-apollo'

import { DINING_OPTIONS } from '../apollo/fulfillment.graphql'
import { useRestaurant } from '../components/RestaurantProvider/RestaurantProvider'

export const DINING_OPTION_BEHAVIORS = {
  DELIVERY: 'DELIVERY',
  OUTPOST: 'OUTPOST',
  TAKE_OUT: 'TAKE_OUT'
}

export const DINING_OPTION_STRINGS = {
  [DINING_OPTION_BEHAVIORS.DELIVERY]: 'Delivery',
  [DINING_OPTION_BEHAVIORS.TAKE_OUT]: 'Pickup',
  [DINING_OPTION_BEHAVIORS.OUTPOST]: 'Outpost'
}

export const useDiningOptions = ({ networkOnly = false } = {}) => {
  const { restaurantGuid } = useRestaurant()
  const diningOptionsInput = {
    input: {
      restaurantGuid,
      includeBehaviors: [] // lol
    }
  }

  return useQuery(DINING_OPTIONS, {
    variables: diningOptionsInput,
    fetchPolicy: networkOnly ? 'network-only' : 'cache-first'
  })
}
